<template>
	<div class="secondpage">
		<div class="title_top">
			<el-row :gutter="20">
				<el-col :span="16" :offset="4">
					<div class="secondpage_con">
						<h2>联系我们</h2>
						<p>咨询网站所列技术服务</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 内容 -->
		<el-row class="phonebox">
			<el-col :span="16" :offset="4">
				<el-row>
					<el-col :xs="24">
						<h3>联系方式</h3>
						<p>如需了解网站所列技术服务，可通过以下方式咨询</p>
					</el-col>
					<el-col :xs="24" :sm="8" v-for="(phonelist, index) in content" :key="index">
						<img :src="'../../static/' + phonelist.imgsrc" width="30%" alt="">
						<h4>{{phonelist.title}}</h4>
						<p>{{phonelist.phonenum}}</p>
					</el-col>
				</el-row>
			</el-col>
		</el-row>

		<el-row class="formbox">
			<el-col :span="16" :offset="4">
				<el-row>
					<el-col :xs="24" :sm="24" class="formleft_box">
						<h2>邮箱咨询</h2>
						<p>
							可发送邮件至
							<a href="mailto:2996762481@qq.com">2996762481@qq.com</a>
							咨询网站所列技术服务。
						</p>
					</el-col>
				</el-row>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				workTask: [],
				content:[
					{
						id:1,
						imgsrc:'1587_jhh3umir.png',
						title:'电子邮箱',
						phonenum:'2996762481@qq.com'
					},
					{
						id:1,
						imgsrc:'1587_jhh3qqh1.png',
						title:'公司地址',
						phonenum:'广州市天河区黄村三联路12号B2栋一楼B1097'
					},
					{
						id:1,
						imgsrc:'1587_jhh3uzi5.png',
						title:'工作时间',
						phonenum:'周一至周五 9:00-18:00'
					}
				]
			};
		},
		created() {
			this.workTask = this.$route.query.id
			console.log(this.workTask)
		}

	}
</script>

<style scoped>
	.title_top {
		width: 100%;
		overflow: hidden;
		margin: 0;
		color: #FFFFFF;
		background: url(../assets/1587_jgzynhtp.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.secondpage_con {
		margin: 150px auto;
	}
	.phonebox{
		margin: 50px auto;
	}
	.phonebox p,.phonebox h3,.phonebox h4{
		color: #000000;
	}

	.formbox{
		padding-top: 50px;
		padding-bottom: 50px;
		background-color: rgb(248, 248, 249);
	}
	.formleft_box{
		text-align: left;
		color: #000000;
		padding-right:50px ;
	}
</style>



// WEBPACK FOOTER //
// src/components/contactus.vue